import styled from 'styled-components'
import {backgroundColor, lightGray} from '@modifi/colors'
import {BaseFormFooterContainer} from '../../../../ui/form'

export const FooterWrapper = styled(BaseFormFooterContainer)`
  background-color: ${backgroundColor};
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  justify-content: end;
  border-radius: 0 0 6px 6px;
  margin-top: auto;
  border: 1px solid ${lightGray};
`
